<mat-dialog-content>
    <mat-dialog-title>{{ title }}</mat-dialog-title>
    <div class="alert-text-area">
        {{ message }}
        <span *ngIf="valueType === 'MobilePhone'">{{ value | mask: '(000) 000-0000' }}</span>
    </div>
    <mat-dialog-actions>
        <button mat-button (click)="close('accept')">
            YES
        </button>
        <button mat-button class="button-gray" (click)="close('close')">
            NO
        </button>
    </mat-dialog-actions>
</mat-dialog-content>
